<div ref="mobileContainerRef" class="mobile-view-container">
  <router-view />
</div>
